import * as React from "react";
import { IconProps } from "./IconProps";

export const IconOpenLink = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M0.5 0C0.166667 0 0 0.166667 0 0.5V7.5C0 7.83333 0.166667 8 0.5 8H7.5C7.83333 8 8 7.83333 8 7.5V4.33333C8 4.14924 7.85076 4 7.66667 4C7.48257 4 7.33333 4.14924 7.33333 4.33333L7.33333 7.16667C7.33333 7.22222 7.3 7.33333 7.16667 7.33333L0.833333 7.33333C0.777778 7.33333 0.666667 7.3 0.666667 7.16667V0.833333C0.666667 0.7 0.777778 0.666667 0.833333 0.666667H3.66667C3.85076 0.666667 4 0.517428 4 0.333333C4 0.149238 3.85076 0 3.66667 0H0.5Z"
          fill={color}
        />
        <path
          d="M5.21446 0.558969L7.57148 0.0875643C7.61438 0.0786075 7.65869 0.0786075 7.70182 0.0873285C7.88261 0.123391 7.99975 0.298989 7.96345 0.479537L7.49205 2.83656C7.47932 2.90114 7.4475 2.9603 7.40083 3.00697C7.26954 3.13449 7.06071 3.13449 6.92943 3.00697L6.34017 2.41772L4.21885 4.53904C4.02369 4.7342 3.70691 4.7342 3.51174 4.53904C3.31658 4.34387 3.31658 4.02709 3.51174 3.83193L5.63306 1.71061L5.04381 1.12135C4.99738 1.07492 4.96579 1.01552 4.95283 0.951178C4.91676 0.770394 5.03391 0.594796 5.21446 0.558969Z"
          fill={color}
        />
      </svg>
    );
  },
);
